/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import { Location } from 'vue-router';
import { getLocal, setLocal } from './storage';
import { RouteInfo } from './navigation';

export interface NavItem {
  key: string;
  type: string;
  subType: string;
}

export const getNavsLocal = (game: string): NavItem[] => getLocal(`secret/navs/${game}`) || [];
export const setNavsLocal = (game: string, navs: NavItem[]): void => setLocal(`secret/navs/${game}`, navs);

/**
 * 通过路由计算帖子列表 filter 数据
 * @param {RouteInfo} route 路由
 * @param {string} startFilter 默认 filter 数据
 * @returns {string} 实际生效的 filter 数据
 */
export const stringifyPostsRoute = (route: Location, startFilter: string = ''): string => {
  const paths: string[] = [];
  if (route.params) {
    while (route.params[`p${paths.length}`]) {
      paths[paths.length] = route.params[`p${paths.length}`];
    }
  }
  if (paths[0] === 'posts') {
    paths.shift();
  }
  const filter = paths.join('_');
  if (!filter) {
    // 优先使用本地存储的上次浏览filter作为默认filter使用
    const nav = getNavsLocal(startFilter).find(s => s.key === 'default_all');
    return nav ? nav.subType : startFilter;
  }
  return filter;
};

/**
 * 通过帖子列表 filter 数据计算路由
 * @param {string} filter filter 数据
 * @returns {RouteInfo} 路由数据
 */
export const parsePostsRoute = (filter: string): RouteInfo => {
  const [path, queryString = ''] = filter.split('?');
  const paths = path.split('_');
  if (!['posts', 'topic', 'room', 'game'].includes(paths[0])) {
    paths.unshift('posts');
  }
  let i = 0;
  const params: Record<string, string> = {};
  while (paths.length) {
    if (i < 2) {
      params[`p${i}`] = paths[0];
      paths.shift();
    } else {
      params[`p${i}`] = paths.join('_');
      break;
    }
    i += 1;
  }
  const query = {};
  if (queryString) {
    queryString.split('&').forEach((s) => {
      const [k, v] = s.split('=');
      if (k && v) {
        query[decodeURIComponent(k)] = decodeURIComponent(v);
      }
    });
  }
  return { name: 'secret_list', params, query };
};

/**
 * 标准化帖子列表路由
 * @param {RouteInfo} route 路由
 * @param {string} startFilter 默认 filter 数据
 * @returns {string} 标准化的路由
 */
export const standardizePostsRoute = (route: Location, startFilter: string = ''): RouteInfo =>
  parsePostsRoute(stringifyPostsRoute(route, startFilter));
